export default __webpack_public_path__ + "static/media/include_16@3x.d97c0668.jpg";